import { FunnelType } from '../../types/enums/FunnelType';
import { TRANSIENT_GROUP_ID } from './useFunnelMapElements';

export const FULL_NAME_SEPARATOR = '%&?';

export const recordTypeToNodeId = (recordTypeId: string, fullName: string) => {
  return `${recordTypeId}${FULL_NAME_SEPARATOR}${fullName}`;
};

export const nodeIdToRecordTypePicklistFullName = (id: string) => {
  const [, recordTypePicklistFullName] = id.split(FULL_NAME_SEPARATOR);
  return recordTypePicklistFullName;
};

export const getFunnelTypeFromNodeId = (
  funnelMap: FunnelMap,
  nodeId: string,
): FunnelType | undefined => {
  if (Object.keys(funnelMap.funnels).includes(nodeId)) {
    return FunnelType.SALESFORCE;
  }
  if (Object.keys(funnelMap.hubspotFunnels).includes(nodeId)) {
    return FunnelType.HUBSPOT;
  }
  if (Object.keys(funnelMap.thirdPartyFunnels || {}).includes(nodeId)) {
    return FunnelType.THIRD_PARTY;
  }
  if (Object.keys(funnelMap.metadataElements).includes(nodeId)) {
    return FunnelType.METADATA_ELEMENT;
  }
  if (Object.keys(funnelMap.stickyNotes || {}).includes(nodeId)) {
    return FunnelType.STICKY_NOTE;
  }
  if (!Object.keys(funnelMap.recordTypes).includes(nodeId) && nodeId !== TRANSIENT_GROUP_ID) {
    return undefined;
  }

  return FunnelType.RECORD_TYPE;
};

const COMPOSED_ID_PREFIX = '_cmp_:';
const COMPOSED_ID_SEPARATOR = '|';

export const createFunnelStageCompositeId = (funnelId: string, stageId: string) => {
  return `${COMPOSED_ID_PREFIX}${funnelId}${COMPOSED_ID_SEPARATOR}${stageId}`;
};

const isComposedId = (id: string) => {
  return id.startsWith(COMPOSED_ID_PREFIX) && id.split(COMPOSED_ID_SEPARATOR).length === 2;
};

export const parsePossibleFunnelStageCompositeId = (
  compositeId: string,
): { funnelId?: string; stageId: string } => {
  if (!isComposedId(compositeId)) {
    return { stageId: compositeId };
  }
  const [funnelId, stageId] = compositeId
    .slice(COMPOSED_ID_PREFIX.length)
    .split(COMPOSED_ID_SEPARATOR);
  return { funnelId, stageId };
};

export const createEdgeCompositeId = (...args: (string | undefined)[]) => {
  return args.filter(Boolean).join('-');
};

export const createFunnelLabelCompositeId = (funnelId: string) => {
  return `label-${funnelId}`;
};

export const createTargetFunnelLinkCompositeId = (funnelLink: FunnelLink) => {
  if (funnelLink.stageId) {
    if (funnelLink._type === FunnelType.SALESFORCE) {
      return createFunnelStageCompositeId(funnelLink.funnelId, funnelLink.stageId);
    }
    return funnelLink.stageId;
  }
  if (funnelLink._type === FunnelType.SALESFORCE) {
    return createFunnelLabelCompositeId(funnelLink.funnelId);
  }
  return funnelLink.funnelId;
};
